import React from "react";

export default function SearchVideos() {
  return (
    <div>
      <h2>Coming Soon</h2>
    </div>
  );
}
